import React from "react"
import { CONTENT_TYPES } from "@/constants"
import PaymentMain from "@/components/payment/PaymentMain"

const Inline = ({ data }) => {
	switch (data.__typename) {
		case CONTENT_TYPES.SINGLE_PAGE:
			return <span>TU JEST LINK DO SINGLE PAGE</span>
		case CONTENT_TYPES.PAYMENT_MODULE:
			return (
				<div className="full-width">
					<PaymentMain data={data} />
				</div>
			)
		default:
			return null
	}
}

export default Inline
